import WResultsTraits from './WResultsTraits'

export default WResultsTraits
